export default "__VITE_ASSET__DTFzifRT__"